import { ApiFilterConfig } from '../api/api-filter-config';

export const defaultApiFilterConfig: ApiFilterConfig = {
    page: '1',
    itemsPerPage: '25'
};
